// @noflow
import type { ColumnId, TabName } from './ComparisonTable'

type Columns = { id: ColumnId; label: string | null; asset: string | null }[]

type DataRow = {
  feature: {
    icon: string
    text: string
  }
} & Record<Exclude<ColumnId, 'column_0'>, boolean>

const columns: Columns = [
  { id: 'column_0', label: null, asset: null },
  {
    id: 'column_1',
    label: 'table.columns.column_1',
    asset: 'butternut-meal-phase-3'
  },
  { id: 'column_2', label: 'table.columns.column_2', asset: 'kibble-bowl' },
  { id: 'column_3', label: 'table.columns.column_3', asset: 'wet-bowl' },
  { id: 'column_4', label: 'table.columns.column_4', asset: 'raw-bowl' }
]

const data: DataRow[] = [
  {
    feature: {
      icon: 'phase-3-carrot',
      text: 'table.rows.row_1'
    },
    column_1: true,
    column_2: false,
    column_3: false,
    column_4: true
  },
  {
    feature: {
      icon: 'phase-3-pot',
      text: 'table.rows.row_2'
    },
    column_1: true,
    column_2: false,
    column_3: false,
    column_4: false
  },
  {
    feature: {
      icon: 'phase-3-beaker',
      text: 'table.rows.row_3'
    },
    column_1: true,
    column_2: false,
    column_3: false,
    column_4: true
  },
  {
    feature: {
      icon: 'phase-3-meat',
      text: 'table.rows.row_4'
    },
    column_1: true,
    column_2: false,
    column_3: false,
    column_4: false
  },
  {
    feature: {
      icon: 'phase-3-frozen',
      text: 'table.rows.row_5'
    },
    column_1: true,
    column_2: false,
    column_3: false,
    column_4: false
  }
]

const reviews = (
  selectedTab: TabName
): Array<{ name: string; copy: string; url: string }> => {
  switch (selectedTab) {
    case 'column_2':
      return [
        {
          name: 'Ange',
          copy: 'review_1',
          url: 'https://www.trustpilot.com/reviews/6845ccab71f8e12086e126f5'
        }
      ]
    case 'column_3':
      return [
        {
          name: 'Kharmie',
          copy: 'review_2',
          url: 'https://www.trustpilot.com/reviews/684ad99ab64a4c6b75c4d01e'
        }
      ]
    case 'column_4':
      return [
        {
          name: 'Laura',
          copy: 'review_3',
          url: 'https://www.trustpilot.com/reviews/6812519cb50f34c6f64d420d'
        }
      ]
    case 'all':
      return [
        {
          name: 'Ange',
          copy: 'review_1',
          url: 'https://www.trustpilot.com/reviews/6845ccab71f8e12086e126f5'
        },
        {
          name: 'Kharmie',
          copy: 'review_2',
          url: 'https://www.trustpilot.com/reviews/684ad99ab64a4c6b75c4d01e'
        },
        {
          name: 'Laura',
          copy: 'review_3',
          url: 'https://www.trustpilot.com/reviews/6812519cb50f34c6f64d420d'
        }
      ]
  }
}

const displayedColumnsId = (selectedTab: TabName): Array<ColumnId> => {
  if (selectedTab === 'all') {
    return ['column_0', 'column_1', 'column_2', 'column_3', 'column_4']
  } else return ['column_0', 'column_1', selectedTab]
}

export { columns, data, displayedColumnsId, reviews }
